import { render, staticRenderFns } from "./MyAssetView.vue?vue&type=template&id=1c7b21a7&"
import script from "./MyAssetView.vue?vue&type=script&lang=js&"
export * from "./MyAssetView.vue?vue&type=script&lang=js&"
import style0 from "./MyAssetView.vue?vue&type=style&index=0&id=1c7b21a7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports